import u from "./_common.js";
import { createTheme as f } from "../../_mixins/use-theme.js";
import g from "../../_styles/common/light.js";
import x from "../../input/styles/light.js";
import T from "../../button/styles/light.js";
import b from "../../time-picker/styles/light.js";
import D from "../../_internal/scrollbar/styles/light.js";
import { changeColor as v } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/color/index.js";
function S(m) {
  const {
    hoverColor: r,
    fontSize: e,
    textColor2: t,
    textColorDisabled: d,
    popoverColor: l,
    primaryColor: i,
    borderRadiusSmall: c,
    iconColor: a,
    iconColorDisabled: C,
    textColor1: s,
    dividerColor: o,
    boxShadow2: p,
    borderRadius: n,
    fontWeightStrong: h
  } = m;
  return Object.assign(Object.assign({}, u), {
    itemFontSize: e,
    calendarDaysFontSize: e,
    calendarTitleFontSize: e,
    itemTextColor: t,
    itemTextColorDisabled: d,
    itemTextColorActive: l,
    itemTextColorCurrent: i,
    itemColorIncluded: v(i, {
      alpha: 0.1
    }),
    itemColorHover: r,
    itemColorDisabled: r,
    itemColorActive: i,
    itemBorderRadius: c,
    panelColor: l,
    panelTextColor: t,
    arrowColor: a,
    calendarTitleTextColor: s,
    calendarTitleColorHover: r,
    calendarDaysTextColor: t,
    panelHeaderDividerColor: o,
    calendarDaysDividerColor: o,
    calendarDividerColor: o,
    panelActionDividerColor: o,
    panelBoxShadow: p,
    panelBorderRadius: n,
    calendarTitleFontWeight: h,
    scrollItemBorderRadius: n,
    iconColor: a,
    iconColorDisabled: C
  });
}
const L = f({
  name: "DatePicker",
  common: g,
  peers: {
    Input: x,
    Button: T,
    TimePicker: b,
    Scrollbar: D
  },
  self: S
}), A = L;
export {
  A as default,
  S as self
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/date-picker/styles/light.js
// module id = 1633
// module chunks = 41